const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Flow Builder (Constructor de Flujos)",
    summary:
      "Diseña flujos de conversación interactivos y automatizados sin código. Crea respuestas inteligentes, bifurcaciones de menú, captura de variables, llamadas webhook y transferencia a departamentos o agentes.",
  },
  sections: [
    {
      id: "flujos_automatizados",
      title: "1. Gestión de Flujos de Automatización",
      description:
        "Crea, duplica, exporta y organiza todos tus flujos de chatbot interactivos.",
      items: [
        {
          id: "crear_flujo",
          title: "Creación y Nombre del Flujo",
          definition:
            "Define flujos dedicados a soporte, ventas, bienvenida o encuestas asociándolos a palabras clave o disparadores.",
        },
        {
          id: "editor_nodos",
          title: "Editor Visual por Nodos",
          definition:
            "Conecta nodos de texto, imágenes, audios, menús interactivos, lógica condicional y acciones de backend de forma intuitiva.",
        },
      ],
    },
    {
      id: "disparadores",
      title: "2. Disparadores y Conexiones",
      description:
        "Configuración de disparadores por palabras clave, colas y canales de entrada.",
      items: [
        {
          id: "palabras_clave",
          title: "Palabras Clave y Acceso",
          definition:
            "Configura frases o términos específicos que activan el flujo automáticamente al ingresar un nuevo mensaje.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Flow Builder",
    summary:
      "Design interactive and automated conversation flows without code. Create smart replies, menu branches, variable capture, webhook triggers, and routing to queues or agents.",
  },
  sections: [
    {
      id: "flujos_automatizados",
      title: "1. Automation Flow Management",
      description:
        "Create, duplicate, export, and organize all your interactive chatbot flows.",
      items: [
        {
          id: "crear_flujo",
          title: "Flow Creation & Naming",
          definition:
            "Define dedicated flows for support, sales, greetings, or surveys linked to keywords or triggers.",
        },
        {
          id: "editor_nodos",
          title: "Visual Node Editor",
          definition:
            "Connect text, media, interactive menus, conditional logic, and backend actions intuitively.",
        },
      ],
    },
    {
      id: "disparadores",
      title: "2. Triggers & Channels",
      description:
        "Configure triggers by keywords, queues, and incoming channels.",
      items: [
        {
          id: "palabras_clave",
          title: "Keywords & Triggers",
          definition:
            "Set specific phrases or terms that automatically fire the flow upon receiving a customer message.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "Flow Builder (Construtor de Fluxos)",
    summary:
      "Crie fluxos de conversa interativos e automatizados sem código. Desenvolva respostas inteligentes, ramificações de menu, captura de variáveis, webhooks e transferência para setores ou agentes.",
  },
  sections: [
    {
      id: "flujos_automatizados",
      title: "1. Gestão de Fluxos de Automação",
      description:
        "Crie, duplique, exporte e organize todos os seus fluxos de chatbot interativos.",
      items: [
        {
          id: "crear_flujo",
          title: "Criação e Nome do Fluxo",
          definition:
            "Defina fluxos específicos para suporte, vendas, boas-vindas ou pesquisas vinculados a palavras-chave.",
        },
        {
          id: "editor_nodos",
          title: "Editor Visual de Nós",
          definition:
            "Conecte nós de mensagem, mídia, menus interativos, lógica condicional e ações de backend com facilidade.",
        },
      ],
    },
    {
      id: "disparadores",
      title: "2. Gatilhos e Conexões",
      description:
        "Configuração de gatilhos por palavras-chave, filas e canais de entrada.",
      items: [
        {
          id: "palabras_clave",
          title: "Palavras-chave e Acesso",
          definition:
            "Defina termos ou frases que iniciam o fluxo automaticamente quando uma mensagem é recebida.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Flow Builder (Créateur de Flux)",
    summary:
      "Concevez des parcours de discussion interactifs et automatisés sans code. Définissez des réponses intelligentes, des embranchements de menu, la capture de variables et le transfert vers des agents.",
  },
  sections: [
    {
      id: "flujos_automatizados",
      title: "1. Gestion des Flux d'Automatisation",
      description:
        "Créez, dupliquez, exportez et organisez tous vos flux de chatbot interactifs.",
      items: [
        {
          id: "crear_flujo",
          title: "Création et Nom du Flux",
          definition:
            "Définissez des flux dédiés pour l'assistance, la vente ou les messages d'accueil associés à des mots-clés.",
        },
        {
          id: "editor_nodos",
          title: "Éditeur Visuel par Nœuds",
          definition:
            "Reliez facilement des nœuds de texte, médias, menus interactifs et conditions logiques.",
        },
      ],
    },
    {
      id: "disparadores",
      title: "2. Déclencheurs et Canaux",
      description:
        "Configuration des déclencheurs par mots-clés et files d'attente.",
      items: [
        {
          id: "palabras_clave",
          title: "Mots-clés Déclencheurs",
          definition:
            "Configurez des termes précis déclenchant instantanément le flux à l'arrivée d'un message client.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "منشئ التدفقات (Flow Builder)",
    summary:
      "صمم مسارات محادثة تفاعلية ومؤتمتة بدون كتابة أكواد. أنشئ ردوداً ذكية وتفريعات للقوائم والتقاط للمتغيرات وتوجيه المحادثات للموظفين والأقسام.",
  },
  sections: [
    {
      id: "flujos_automatizados",
      title: "1. إدارة تدفقات الأتمتة",
      description:
        "إنشاء واستنساخ وتصدير وتنظيم جميع تدفقات المحادثة الآلية التفاعلية.",
      items: [
        {
          id: "crear_flujo",
          title: "إنشاء التدفق وتسميته",
          definition:
            "حدد مسارات مخصصة لخدمة العملاء أو المبيعات أو الترحيب وربطها بالكلمات المفتاحية.",
        },
        {
          id: "editor_nodos",
          title: "محرر العقد المرئي",
          definition:
            "اربط عقد النصوص والوسائط والقوائم التفاعلية والمنطق الشرطي وإجراءات النظام بسهولة تامة.",
        },
      ],
    },
    {
      id: "disparadores",
      title: "2. المشغلات والقنوات",
      description:
        "إعداد المشغلات التلقائية بواسطة الكلمات المفتاحية والأقسام والقنوات الواردة.",
      items: [
        {
          id: "palabras_clave",
          title: "الكلمات المفتاحية",
          definition:
            "حدد كلمات أو عبارات محددة تؤدي لبدء التدفق فور استلام رسالة العميل.",
        },
      ],
    },
  ],
};

export const FLOW_BUILDER_HELP_DATA = { es, en, pt, fr, ar };
export default FLOW_BUILDER_HELP_DATA;
